import { BCDataGrid } from '@bimser/components';
import { IDictionary, MLHelper } from '@bimser/core';
import DataGrid2 from '../..';
import { CustomizedDxColumn } from './generateColumns';

function calculateDisplayValue(this: CustomizedDxColumn, row: IDictionary<any>) {
	return MLHelper.getMLText(row[this.dataField]);
}

function calculateFilterExpression(
	this: CustomizedDxColumn,
	filterValue: string,
	selectedFilterOperation: string
) {
	return [
		[
			`${this.dataField}.${MLHelper.currentLanguage.culture}`,
			selectedFilterOperation || 'contains',
			filterValue
		]
	];
}

export const setMultiLanguageTextBox = (dataGrid: DataGrid2, dxColumn: CustomizedDxColumn) => {
	dxColumn.editCellComponent = BCDataGrid.Components.MLTextBox;
	dxColumn.calculateDisplayValue = calculateDisplayValue;

	if (dataGrid.saveMode !== 'self') {
		dxColumn.calculateFilterExpression = calculateFilterExpression;
	}
};
